import React, { useCallback, useContext } from 'react';
import { IOverflowSetItemProps, OverflowSet } from '@fluentui/react';
import { IOverflowMenuProps } from './OverflowMenu.types';
import { FlexPanelCollections } from '../SuiteHeader.types';
import { SuiteHeaderContext } from '../SuiteHeaderProvider';
import { HeaderButton } from '../HeaderButton';
import { defaultForegroundColor } from '../constants';

const onRenderItem = (_item: IOverflowSetItemProps) => <div />;

export const OverflowMenu: React.FunctionComponent<IOverflowMenuProps> = props => {
  const { extraActions = [], changePanelStatus } = props;
  const context = useContext(SuiteHeaderContext);
  const theme = context.theme;
  const { moreOptions, helpPanelHeaderText, organizations } = context.localizationMap;

  const onRenderOverflowButton = useCallback(
    (overflowItems: any[] | undefined): JSX.Element => {
      return (
        <HeaderButton
          role="menuitem"
          title={moreOptions}
          menuIconProps={{
            iconName: 'More',
            styles: {
              root: {
                color: theme?.foregroundColor || defaultForegroundColor
              }
            }
          }}
          menuProps={{ items: overflowItems ?? [] }}
        />
      );
    },
    [moreOptions, theme?.foregroundColor]
  );

  const handleOverflowItemClick = useCallback(
    (id: FlexPanelCollections) => () => {
      changePanelStatus(id, true);
    },
    [changePanelStatus]
  );

  const extraOverflowItemProps = extraActions.map(
    (buttonProps, i): IOverflowSetItemProps => ({
      key: `extra-${i}`,
      name: buttonProps.title,
      iconProps: {
        iconName: buttonProps.iconName,
        styles: {
          root: { color: defaultForegroundColor }
        }
      },
      onClick: buttonProps.onClick
    })
  );

  return (
    <OverflowSet
      aria-label={moreOptions}
      role="menubar"
      overflowItems={[
        ...extraOverflowItemProps,
        {
          key: FlexPanelCollections.organizations,
          name: organizations,
          iconProps: {
            iconName: 'Org',
            styles: {
              root: { color: defaultForegroundColor }
            }
          },
          onClick: handleOverflowItemClick(FlexPanelCollections.organizations)
        },
        {
          key: FlexPanelCollections.help,
          name: helpPanelHeaderText,
          iconProps: {
            iconName: 'Help',
            styles: {
              root: { color: defaultForegroundColor }
            }
          },
          onClick: handleOverflowItemClick(FlexPanelCollections.help)
        }
      ]}
      onRenderOverflowButton={onRenderOverflowButton}
      onRenderItem={onRenderItem}
    />
  );
};
